import {Component, OnInit, ElementRef, ViewChildren, QueryList} from '@angular/core';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {FormBuilder, FormGroup, Validators, FormControl} from '@angular/forms';
import { MatStepper, MatHorizontalStepper } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { InfoDialogComponent } from "./info-dialog/info-dialog.component";
import { Router } from '@angular/router';
import { TeslService } from '../../tesl.service';
import { TeslSchema } from '../../tesl-schema';
import { LoaderService } from '../../common/loader/loader.service'
import { CommonService } from '../../common.service';
import { RecommendationCardComponent } from "./recommendation-card/recommendation-card.component"
import { ChangeDetectorRef } from '@angular/core';



const states_dict = {'Bakery':1, "Dry Cleaner":2, 'Florist':3, "Hardware":4};

const states = ['Bakery','Dry Cleaner','Florist','Hardware'];
@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss']
})

export class BusinessComponent implements OnInit {

  resourcesLoaded: boolean;
  rent:number;//= 2;
  delivery:number;// = 1;
  deliveriesRange;//: number = 3;
  onlineSales: number;// = 1;
  model: any;
  showCoverage: boolean = true;
  showCards: boolean = true;
  businessPanelOpen = true;
  continueToPayment = false;
  select_sales_first_flag = 0;

  stepAllowOne = false; // first stepper
  stepAllowTwo = false; // seconda stepper
  stepAllowThree = false; // third stepper

  previousStepValue = 0;
  currentStepValue = 0;
  //stepper
  isLinear = false;
  businessDetailsForm: FormGroup;
  paymentForm: FormGroup;
  businessAddressForm: FormGroup;

  zip_code_business=""
  industry_type="";
  business_industry_focus = 0;
  num_employees="";
  username="";
  business_name="";
  business_email="";
  business_address="";
  business_city="";
  business_state="";
  business_zipcode="";
  billing_address="";
  billing_city="";
  billing_state="";
  billing_zip_code="";
  phone_number = "";
  annual_revenue = "Less than $100,000";
  annual_revenue_midpoint = "50000";
  credit_card_number = "";
  card_name = "";
  cvv = "";
  expiry = "";

  filtered_coverage = [];
  coverage_filtered_total = 0;
  percent_sales=0;
  last_length_number = 3;

  coverage = [];

  options = "";

  displayValue = '$10,000 - $25,000';

  sales = [
    {value: '', viewValue: 'Less than $100,000', 'id': "1", "midpoint": "50000"},
    {value: '', viewValue: '$100,001 - $300,000', 'id': "2", "midpoint": "200000"},
    {value: '', viewValue: '$300,001 - $500,000', 'id': "3", "midpoint": "400000"},
    {value: '', viewValue: '$500,001 - $700,000', 'id': "4", "midpoint": "600000"},
    {value: '', viewValue: 'Greater than $700,001', 'id': "5", "midpoint": "1000000"}
  ];

  billingFreq = [
    {value: '', viewValue: 'Monthly'},
    {value: '', viewValue: 'Quarterly'},
    {value: '', viewValue: 'Pay in full'}
  ]

  coverageToField = {
   1: "ProtectsyourbusinessoperationsphysicalassetsTF",
   2: "ProtectsyouremployeesforworkrelatedaccidentsTF",
   3: "ProtectsemployeesdrivingforyourbusinessTF",
   4: "ProtectsyourgoodsinyourtruckTF",
   5: "ProtectsyourdatacustomersinfoTF",
   6: "ProtectsyourgeneralliabilityTF"
  }

  stateCodeToNumberMapping= {
    "AL" : 1 ,
    "AK" : 2 ,
    "AZ" : 3 ,
    "AR" : 4 ,
    "CA" : 5 ,
    "CO" : 6 ,
    "CT" : 7 ,
    "DE" : 8 ,
    "FL" : 9 ,
    "GA" : 10 ,
    "HI" : 11 ,
    "ID" : 12 ,
    "IL" : 13 ,
    "IN" : 14 ,
    "IA" : 15 ,
    "KS" : 16 ,
    "KY" : 17 ,
    "LA" : 18 ,
    "ME" : 19 ,
    "MD" : 20 ,
    "MA" : 21 ,
    "MI" : 22 ,
    "MN" : 23 ,
    "MS" : 24 ,
    "MO" : 25 ,
    "MT" : 26 ,
    "NE" : 27 ,
    "NV" : 28 ,
    "NH" : 29 ,
    "NJ" : 30 ,
    "NM" : 31 ,
    "NY" : 32 ,
    "NC" : 33 ,
    "ND" : 34 ,
    "OH" : 35 ,
    "OK" : 36 ,
    "OR" : 37 ,
    "PA" : 38 ,
    "RI" : 40 ,
    "SC" : 41 ,
    "SD" : 42 ,
    "TN" : 43 ,
    "TX" : 44 ,
    "UT" : 45 ,
    "VT" : 46 ,
    "VA" : 47 ,
    "WA" : 48 ,
    "DC" : 49 ,
    "WV" : 50 ,
    "WI" : 51 ,
    "WY" : 52 ,
  }

  stateToNumberMapping = {
    'alabama':1,
    'alaska':2,
    'arizona':3,
    'arkansas':4,
    'california':5,
    'colorado':6,
    'connecticut':7,
    'delaware':8,
    'florida':9,
    'georgia':10,
    'hawaii':11,
    'idaho':12,
    'illinois':13,
    'indiana':14,
    'iowa':15,
    'kansas':16,
    'kentucky':17,
    'louisiana':18,
    'maine':19,
    'maryland':20,
    'massachusetts':21,
    'michigan':22,
    'minnesota':23,
    'mississippi':24,
    'missouri':25,
    'montana':26,
    'nebraska':27,
    'nevada':28,
    'newhampshire':29,
    'newjersey':30,
    'newmexico':31,
    'newyork':32,
    'northcarolina':33,
    'northdakota':34,
    'ohio':35,
    'oklahoma':36,
    'oregon':37,
    'pennsylvania':38,
    'puertorico':39,
    'rhodeisland':40,
    'southcarolina':41,
    'southdakota':42,
    'tennessee':43,
    'texas':44,
    'utah':45,
    'vermont':46,
    'virginia':47,
    'washington':48,
    'washingtondc':49,
    'westvirginia':50,
    'wisconsin':51,
    'wyoming':52
  }

  flag = 1;
  isZipReadOnly = false;


  pr: any;
  
  session_created = false;
  
  initiateQuoteSuccess = false;
  phone_number_str = "";

  phoneNumberOriginal = "";
  phoneNumber = "";
  selectedIndex = 0;
  checkedSameAddress = false;


  @ViewChildren(RecommendationCardComponent) recommedation_cards: QueryList<RecommendationCardComponent>


  constructor(private _formBuilder: FormBuilder, public dialog: MatDialog, private tesl: TeslService, private route_to: Router, private loaderService: LoaderService, private commonService: CommonService, private cdr: ChangeDetectorRef) {
  }
  

  ngOnInit() {
    this.commonService.changeHeaderLeftIcon("../../../assets/icons/menu.svg")

    CommonService.setToInitialCoverage();
    this.coverage = CommonService.coverage;
    CommonService.filtered_coverage = CommonService.coverage;
    CommonService.coverage_options_selected = [1,2,3,4,5,6];
    CommonService.filtered_total = CommonService.coverage_total;
    CommonService.filer_coverage_values();
    // CommonService.total_filtered_values();
    this.filtered_coverage = CommonService.coverage;
    this.coverage_filtered_total = CommonService.coverage_total;
    CommonService.calculatePrice();
    this.commonService.changeHeader('your details')

    if(this.commonService.isResponsive()) {
      this.showCards = true;
      this.showCoverage = false;
    }
  
    this.businessDetailsForm = this._formBuilder.group({
      zip: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{5}$')]),
      industry: new FormControl('', Validators.required),
      emp: new FormControl('', [Validators.required, Validators.pattern('^[1-9][0-9]*$')]),
      // salary: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      monthlySales: new FormControl(''),

    });

    this.paymentForm = this._formBuilder.group({
      number: new FormControl('', [Validators.required, Validators.maxLength(19)]),
      expiry: new FormControl('', [Validators.required, Validators.maxLength(5)]),
      cvv: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{3}$')]),
      name: new FormControl('', Validators.required),
      freq: new FormControl('', Validators.required)
    });

    this.businessAddressForm = this._formBuilder.group({
      name: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z]+[\s][a-zA-Z ]+$/)]),
      nob: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      address: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zip: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{5}$')]),
      billingAddress: new FormControl('', Validators.required),
      billingCity: new FormControl('', Validators.required),
      billingState: new FormControl('', Validators.required),
      billingZip: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{5}$')]),
      checkedSameAddress: new FormControl('', Validators.required),
      phone: new FormControl('', [Validators.required, Validators.pattern('^[+][1][\s(]*[1-9][0-9]{2}[\s)-]*[0-9]{3}[\s-]*[0-9]{4}$')])//, Validators.pattern('/^[\+]?[(]?[2-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im')])
    });
    
    this.commonService.currentOptions.subscribe(filtered_coverage => this.filtered_coverage = filtered_coverage);
    this.commonService.currentCoverageTotal.subscribe(total_filtered_coverage => this.coverage_filtered_total = total_filtered_coverage);
    this.commonService.currentAllCoverage.subscribe(coverage => this.coverage = coverage);
    //this.filtered_coverage = CommonService.filtered_coverage;
    // this.testFunction()
  }

  numberToString(value){
    value = value+"";
    value = +value;

    return(this.commaSeperatedNumber(parseFloat(value+"").toFixed(2)+""));
  }

  commaSeperatedNumber(value){
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  phoneNumberDomainControl(control: FormControl) { 
    var phonenumber = control.value;
    
    return null; 
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  businessPanelOpenEvent(){
    if(this.phone_number != null){
    }
  }

  format_phone_number(){
    var pno = this.phone_number.replace(/\s/g, "");
    pno = pno.replace("(", "");
    pno = pno.replace(")", "");
    pno = pno.replace("-", "");
   
    return pno;
  }

  selectRent(value) {
    this.rent = value;
  }

  openDialog(id): void {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      data: { 'id': id }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  selectDelivery(value) {
    this.delivery = value;
  }

  selectSales(value) {
    this.onlineSales = value;
    if(this.select_sales_first_flag == 1 && value == 1)
    {  
      this.select_sales_first_flag = 2;
    }
    else if(this.select_sales_first_flag == 0 && value == 1){
      this.select_sales_first_flag = 1;
    }    
  }

  selectDeliveryRange(value) {
    this.deliveriesRange = value;
  }

  formatLabel(value: number | null) {
    return value + '%';
  }
  
  locateMe() {
    this.businessDetailsForm.controls['zip'].setValue('01760')
  }

  checkDescribeBusinessPage(){
    if(this.business_industry_focus+"" == "undefined"){
      this.industry_type = "";
      this.cdr.detectChanges();
      return false;
    }
    else if(this.rent == null || this.rent == 0){
      this.rent = 0;
      return false;
    }
    else if(this.num_employees == null || this.num_employees == "0"){
       return false;
    }
    else if(this.delivery == null || this.delivery == 0){
      this.delivery = 0;
      return false;
    }
    else if(this.deliveriesRange == null && this.delivery == 1 || this.deliveriesRange == 0 ){
      this.deliveriesRange = 0;
      return false;
    }
    else if(this.onlineSales == null || this.onlineSales == 0){
      this.onlineSales = 0;
      return false;
    }
    return true;
  }

  checkAndSendCoverageValues(id, payload, select_status = true){

    for(let i = 0;i<CommonService.coverage.length; i++){
      if(CommonService.coverage[i].id == id)
      {
        var updated_value = +((""+this.coverage[i].coverage).replace(",",""));
        if(id == 1 ){
          if(select_status == true)
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['PropertyCoverageAmount'] = updated_value;
          else{
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['PropertyCoverageAmount'] = 0;
          }
        }
        else if(id == 2){
          if(select_status == true)
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['AccidentCoverageAmount'] = updated_value;
          else{
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['AccidentCoverageAmount'] = 0;

          }
        }
        else if(id == 3){
          if(select_status == true)
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['VehicleAndDriverCoverageAmount'] = updated_value;
          else
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['VehicleAndDriverCoverageAmount'] = 0;

        }
        else if(id == 4){
          if(select_status == true)
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['GoodsCargoCoverageAmount'] = updated_value;
          else
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['GoodsCargoCoverageAmount'] = 0;

        }
        else if(id == 5){
          if(select_status == true)
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['DataCoverageAmount'] = updated_value;
          else
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['DataCoverageAmount'] = 0;
        }
        else if(id == 6){
          if(select_status == true)
            payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['LiabilityCoverageAmount'] = updated_value;
          else
          payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['LiabilityCoverageAmount'] = 0;
        }
      }
    }
    return payload;
  }

  checkIdCoverage(id){
    for(let i = 0;i<CommonService.filtered_coverage.length; i++){
      if(CommonService.filtered_coverage[i].id == id)
      {
        return 1;
      }
    }
    return 0;
  }

  nextStep(stepper: MatStepper, header: string, sType: string){
    window.scrollTo(0, 0)
    var goToNextPage = true;
    if(header == "recommendation"){

      this.recommedation_cards.forEach((card) => { card.resetState(); });
      this.getBusinesIndustryFocus();
      goToNextPage = this.checkDescribeBusinessPage();
      if(goToNextPage == true){
        if (this.commonService.isResponsive()) {
          this.showCoverage = false
          this.showCards = true
        }
        this.reInitSchema();
        this.stepAllowOne = true;
        this.stepAllowTwo = true;
        this.stepAllowThree = false;
        this.businessAddressForm.controls['billingZip'].setValue( this.zip_code_business);
        this.businessAddressForm.controls['zip'].setValue( this.zip_code_business);
        this.isZipReadOnly = false;

        if(this.flag == 1 ){
          this.loaderService.show();

          // Create Session
          if(this.session_created == false)
          this.pr = this.tesl.createSession().then((data) => {
          });
          var payload_initial = TeslSchema.INITIATE_QUOTE_DATA;

          payload_initial['Submission']["SubmissionAddress"][0]["AddressZIPCode"] = this.zip_code_business;
          payload_initial['Submission']["SubmissionAddress"][1]["AddressZIPCode"] = this.zip_code_business;
          this.pr = this.pr.then(() => {
              // CommonService.coverage = CommonService.original_coverage;
              this.commonService.changeAllCoverage(CommonService.coverage);
              this.session_created = true;
              if(this.initiateQuoteSuccess == false){
              //initiate quote
                this.tesl.initiateQuote(payload_initial).then((data) => {

                  this.initiateQuoteSuccess = true;
                  //read Object
                  this.tesl.readObject().then((data) => {
                    //update the payload
                    var payload = TeslSchema.COVERAGE_UPDATE_DATA;
                    payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Numberofemployees'] = this.num_employees+"";
                    payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Doyouownorrent'] = this.rent+"";
                    payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Revenue'] = this.annual_revenue_midpoint;
                    payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Doyouhaveonlinesales'] = this.onlineSales+"";
                    payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Doyouofferdelivery'] = this.delivery+"";
                    payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['DeliveriesWeek'] = this.deliveriesRange;
                    payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Businessindustryfocus'] = this.business_industry_focus+"";
                    payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['OnlineSalesPercentage'] = this.percent_sales+"";

                    //update object ids
                    this.tesl.updatePayloadWithObjectIDs(payload);

                    //updateObject with new payload
                    this.tesl.updateObject(payload).then((data) => {
                        this.rateFlow(false, true);
                    });
                  });
                });
              }
              else{
                var payload = TeslSchema.COVERAGE_UPDATE_DATA;
                payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Numberofemployees'] = this.num_employees+"";
                payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Doyouownorrent'] = this.rent+"";
                payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Revenue'] = this.annual_revenue_midpoint;
                payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Doyouhaveonlinesales'] = this.onlineSales+"";
                payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Doyouofferdelivery'] = this.delivery+"";
                payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['DeliveriesWeek'] = this.deliveriesRange;
                payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['Businessindustryfocus'] = this.business_industry_focus+"";
                payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['OnlineSalesPercentage'] = this.percent_sales+"";

                //update object ids
                this.tesl.updatePayloadWithObjectIDs(payload);

                //updateObject with new payload
                this.tesl.updateObject(payload).then((data) => {
                    this.rateFlow(false, true);
                });
              }
          });

        // this.loaderService.hide();
       }
       setTimeout(function() { stepper.next(); }, 0);
      }
    }
    else if(header == "payment details"){
      this.stepAllowOne = true;
      this.stepAllowTwo = true;
      this.stepAllowThree = false;
      if(this.flag == 1){
        this.loaderService.show();

        // update coverage toggle values and coverage values
        var payload = TeslSchema.COVERAGE_UPDATE_DATA;

        for(let j=0;j<CommonService.coverage.length; j++){
            if(this.checkIdCoverage(CommonService.coverage[j].id) == 1){
                payload = this.checkAndSendCoverageValues(CommonService.coverage[j].id, payload);
                var updated_value = +((""+this.coverage[j].coverage).replace(",",""));
                payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL'][this.mapCoverageToFields(CommonService.coverage[j].id)] = "1";
            }
            else{
                payload = this.checkAndSendCoverageValues(CommonService.coverage[j].id, payload, false);
                payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL'][this.mapCoverageToFields(CommonService.coverage[j].id)] = "2";
            }
          }
        
          this.tesl.updateObject(payload).then((data) => {
              this.loaderService.hide();
              this.rateFlow(false, false)
          });  
      }
      setTimeout(function() { stepper.next(); }, 0);
    }
    
    // this.commonService.changeHeaderLeftIcon("../../../assets/icons/back_arrow.svg");
    if(goToNextPage == false){
      
    }
    else{
      this.commonService.changeHeader(header)
      
      if (sType === 'purchase') {
        if (this.commonService.isResponsive()) {
          this.showCoverage = !this.showCoverage
          this.showCards = !this.showCards
       }
      }  
    }
  }
    
  onUpdate(event) {
  }

  continue() {
    window.scrollTo(0, 0)
    // this.commonService.changeHeaderLeftIcon("../../../assets/icons/back_arrow.svg")
    this.commonService.changeHeader('review');
    this.showCoverage = !this.showCoverage;
    this.showCards = !this.showCards;
  }

  validateAllFormFields(formGroup: FormGroup) {        
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
 
  toPayment() {
    this.phoneNumber = this.phoneNumberOriginal;
    this.continueToPayment = this.businessAddressForm.valid;    
  }


  strip_phone_format(e) {
    return e.replace(/[\s-()]+/g,"");
  }

  checknumber(e){
    var value = e.match(/[+]1[\d]{0,10}/g) != null;
    return value;
  }

  add_format(e){
    var num = this.strip_phone_format(e);

    if(this.checknumber(num))
    {
      var country_code = num.slice(0,2);
      var first_ = num.slice(2,5);
      var second_ = num.slice(5,8);
      var third_ = num.slice(8,13);
      if(first_.length == 3)
        return country_code+" ("+ first_+ ") "+second_+" "+third_;
      else{
        return country_code+" ("+ first_+ " "+second_+" "+third_;
      }
    }
    return e;
  }

  phoneModelChanged(e)
  { 
    var current_value = e;
    this.phoneNumberOriginal = e;
    var input_element;
    if(document.getElementById("id_phone_number")!=null){
       input_element = document.getElementById("id_phone_number").querySelector("input");
       if(e.length < 2)
       {
         input_element.value = "+1 ";
       }
       else
       {  
         if(this.last_length_number < e.length)
         {
           input_element.value = this.add_format(e);
           this.phone_number_str = input_element.value;
         }
         this.last_length_number = e.length;
       }
    }
  }

  mapCoverageToFields(id){
    // if(id == 1){
    //    return "ProtectsyourbusinessoperationsphysicalassetsTF";
    //  }
    //  else if(id == 2){
    //    return "ProtectsyouremployeesforworkrelatedaccidentsTF";
    //  }
    //  else if(id == 3){
    //    return "ProtectsemployeesdrivingforyourbusinessTF";
    //  }
    //  else if(id == 4){
    //    return "ProtectsyourgoodsinyourtruckTF";
    //  }
    //  else if(id == 5){
    //    return "ProtectsyourdatacustomersinfoTF";
    //  }
    //  else if(id == 6){
    //    return "ProtectsyourgeneralliabilityTF";
    //  }
     return this.coverageToField[id];
  }

  goto_payment= function () {
          
    window.scrollTo(0, 0)
    this.resourcesLoaded = true;
    this.stepAllowThree = true;
    var businessStateNumber = this.mapStateToNumber(this.business_state);
    var billingStateNumber = this.mapStateToNumber(this.billing_state);
    if(!businessStateNumber){
      this.business_state = "";
      this.cdr.detectChanges();
    }
    else if(!billingStateNumber){
      // this.billing_state = "";
      this.billing_state = "";
      this.cdr.detectChanges();
    }
    else if(this.flag == 1){
      this.loaderService.show()
      if(this.session_created == true){
          
        var payload = TeslSchema.COVERAGE_UPDATE_DATA;
        payload['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['BusinessName'] = this.business_name;              //update object ids

        //updateObject with new payload
        this.tesl.updateObject(payload).then((data) => {
          this.tesl.executeWorkflow().then((data) =>{
            this.updateAfter(true);
          });
        });
      }
    }
    else{

      CommonService.policy_id = "ONSH76912";
      CommonService.email_id = this.business_email;

      this.loaderService.hide();
      this.route_to.navigate(['success-page']);
    }
  }


  updateAfter(last_page){

    // create update payload before bind
    var payload = TeslSchema.METHOD_UPDATE_DATA;
    // modify the update payload
    
    //update address information
    var businessStateNumber = this.mapStateToNumber(this.business_state);
    var billingStateNumber = this.mapStateToNumber(this.billing_state);
    if(!businessStateNumber){
      // this.business_state = "";
      this.loaderService.hide();
    }
    else if(!billingStateNumber){
      // this.billing_state = "";
      this.loaderService.hide();
    }
    else
    {
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceAccountInformationAddressLine1'] = this.business_address;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceAccountInformationAddressCity'] = this.business_city;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceAccountInformationAddressStateProvince'] = businessStateNumber
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceAccountInformationAddressZipCode'] = this.business_zipcode;
      
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceAccountInformationBillingAddressLine1'] = this.billing_address;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceAccountInformationBillingAddressCity'] = this.billing_city;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceAccountInformationBillingAddressStateProvince'] = billingStateNumber;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceAccountInformationBillingAddressZipCode'] = this.billing_zip_code;

      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferencePrimaryAddressLine1'] = this.business_address;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferencePrimaryAddressCity'] = this.business_city;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferencePrimaryAddressState'] = billingStateNumber;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferencePrimaryAddressZIPCode'] = this.business_zipcode;
      
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceMailingAddressLine1'] = this.billing_address;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceMailingAddressCity'] = this.billing_city;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceMailingAddressState'] = billingStateNumber;
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceMailingAddressZipCode'] = this.billing_zip_code;
      

      // update phone and email info
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceAccountInformationPreferredPhoneNumber'] = this.phone_number_str.replace(/ /g,"").replace(")","").replace("(","").slice(2);
      payload['QuoteTransaction']['PolicyTransactionPolicy']['ReferenceAccountInformationPreferredEmailAddress'] = this.business_email;

      // update cc details
      payload['QuoteTransaction']['ReferenceCashTransferProfileForCCCreditDebitCardNumber'] = this.credit_card_number.replace(/ /g,"");
      // payload['QuoteTransaction']['ReferenceCashTransferProfileForCCCreditDebitCardType'] = this.billing_zip_code;
      payload['QuoteTransaction']['ReferenceCashTransferProfileForCCFirstName'] = this.card_name.split(" ",2)[0];
      payload['QuoteTransaction']['ReferenceCashTransferProfileForCCLastName'] = this.card_name.split(" ",2)[1];
      // payload['QuoteTransaction']['ReferenceCashTransferProfileForCCPayerType'] = this.billing_zip_code;
      payload['QuoteTransaction']['ReferenceCashTransferProfileForCCExpirationMonth'] = this.expiry.split("/")[0];
      payload['QuoteTransaction']['ReferenceCashTransferProfileForCCExpirationYear'] = this.expiry.split("/")[1];
      payload['QuoteTransaction']['ReferenceCashTransferProfileForCCSecurityCode'] = this.cvv;

      var firstName, lastName;
      var fullName = this.username.indexOf(' ');
      if(fullName == -1){
        firstName = this.username;
        lastName = " "; 
      }
      else{
        var fullNameSplits = [this.username.slice(0,fullName), this.username.slice(fullName+1)];
        firstName = fullNameSplits[0];
        lastName = fullNameSplits[1];
      }
      //updating first name and last name
      payload['QuoteTransaction']['ReferenceCoveragesIncludedPersonPersonNameFirst'] = firstName;
      payload['QuoteTransaction']['ReferenceCoveragesIncludedPersonPersonNameLast'] = lastName;

     
      this.tesl.updatePayloadWithObjectIDs(payload);

      this.tesl.updateObject(payload, "PolicyTransactionPolicy").then((data) => {
        // this.tesl.readObject().then((data) => {
        // });
      }).then((data) => {
        if(last_page == true){
          this.tesl.bindPolicy().then((data)=> {
            this.resourcesLoaded = false;
            CommonService.policy_id = data['Policy']['PolicyNumber'];
            CommonService.email_id = this.business_email; 
           
              this.tesl.readObject().then((data) => {
                // console.log(data);
                this.tesl.tearDownSession().then(()=>{
                  this.loaderService.hide();
                  this.reInitSchema();
                  this.route_to.navigate(['success-page']);
              });
            });        
          });
        }
      })
    }
  }

  rateFlow(last_page = false, reflect_values = false) {
    // RateQuote
    this.tesl.rate(this.commonService, reflect_values).then((data) => {
      if(last_page == true){
        this.tesl.executeWorkflow().then((data) => {
          this.updateAfter(last_page);
        });
      }

      if(reflect_values == true){
        this.coverage_filtered_total = CommonService.filtered_total;
        this.loaderService.hide(); 
      }
    });
  }
  validateCardNo(val) {
    let chIbn = val.split(' ').join('');
    if (chIbn.length > 0) {
      chIbn = chIbn.match(new RegExp('.{1,4}', 'g')).join(' ');
    }
    this.paymentForm.controls['number'].setValue(chIbn);
  }

  validateCardExpiry(val) {
    let chIbn = val.split(' ').join('');
    chIbn = val.split('/').join('');
    if (chIbn.length > 0) {
      chIbn = chIbn.match(new RegExp('.{1,2}', 'g')).join('/');
    }
    this.paymentForm.controls['expiry'].setValue(chIbn);
  }

  validateCVV(val) {
    let chIbn = val.split(' ').join('');
    this.paymentForm.controls['cvv'].setValue(chIbn);
  }

  sameAddress(e) {
    if(e.checked) {
      this.businessAddressForm.controls['billingAddress'].setValue( this.businessAddressForm.controls['address'].value);
      this.businessAddressForm.controls['billingCity'].setValue( this.businessAddressForm.controls['city'].value);
      this.businessAddressForm.controls['billingState'].setValue( this.businessAddressForm.controls['state'].value);
      this.businessAddressForm.controls['billingZip'].setValue( this.businessAddressForm.controls['zip'].value);
    }
  else{
      this.businessAddressForm.controls['billingAddress'].setValue("");
      this.businessAddressForm.controls['billingCity'].setValue("");
      this.businessAddressForm.controls['billingState'].setValue("");
      this.businessAddressForm.controls['billingZip'].setValue("");
    }
  }

  onChangePercent(event){
    this.percent_sales = event.value;
    this.select_sales_first_flag = 2;
  }
  changeAnnualRevenue(event){
    for(let i = 0; i < this.sales.length; i++){
      if(this.annual_revenue == this.sales[i].viewValue){
          this.annual_revenue_midpoint = this.sales[i].midpoint;
          break;
      } 
    }
  }

  getBusinesIndustryFocus(){
    this.business_industry_focus = states_dict[this.industry_type];
  }

  stepChange(e, stepper){
    if(e.selectedIndex == 0){
      this.stepAllowOne = false;
      this.stepAllowThree = false;
      this.commonService.changeHeader("your details");
    }
    else if(e.selectedIndex == 1){
      this.stepAllowTwo = false;
      this.stepAllowOne = true;
      this.stepAllowThree = false;
      this.continueToPayment = false;
      this.cdr.detectChanges();
      if(this.showCoverage == false)
        this.commonService.changeHeader("recommendation");
      else{
        this.commonService.changeHeader("review");
      }
    }
    else{
      this.stepAllowTwo = true;
      this.stepAllowOne = true;
      this.commonService.changeHeader("payment details"); 
    }   
  }

  reInitSchema(){

    var commonService = new CommonService();
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['ProtectsemployeesdrivingforyourbusinessTF'] = "1";
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['ProtectsyourdatacustomersinfoTF'] = "1";
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['ProtectsyourgoodsinyourtruckTF'] = "1";
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['ProtectsyouremployeesforworkrelatedaccidentsTF'] = "1";
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['ProtectsyourbusinessoperationsphysicalassetsTF'] = "1";
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['ProtectsyourgeneralliabilityTF'] = "1";

    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['PropertyCoverageAmount'] = 0;
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['AccidentCoverageAmount'] = 0;
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['VehicleAndDriverCoverageAmount'] = 0;
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['GoodsCargoCoverageAmount'] = 0;
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['DataCoverageAmount'] = 0;
    TeslSchema.COVERAGE_UPDATE_DATA['QuoteTransaction']['PolicyTransactionPolicy']['PolicyCommercial']['PolicyFL']['LiabilityCoverageAmount'] = 0;
  
    CommonService.coverage = commonService.original_coverage;
  }

  mapStateToNumber(value){
    return this.stateCodeToNumberMapping[value.toUpperCase().replace(/ /g,'').replace(",","").replace(".","").replace("-","")];
  }

  // testFunction(){

  //   this.business_address = "New Business Address";
  //   this.business_city = "New City";
  //   this.business_state = "New State";
  //   this.business_zipcode = "99999";
  //   this.billing_address = "New B Address";
  //   this.billing_city = "New B City";
  //   this.billing_state = "New B State";
  //   this.billing_zip_code = "99991";
    

  //   // update phone and email info
  //   this.phone_number_str = "2132131231";
  //   this.business_email = "busness@email.com";

  //   // update cc details
  //   this.credit_card_number = "4242 4242 4242 4242"
  //   this.billing_zip_code = "999999";
  //   this.card_name = "Card Name";
  //   // payload['QuoteTransaction']['ReferenceCashTransferProfileForCCPayerType'] = this.billing_zip_code;
  //   this.expiry = "02/22"
  //   this.cvv = "222";

  //   this.pr = this.tesl.createSession().then((data) => {
  //   });
  //   var payload_initial = TeslSchema.INITIATE_QUOTE_DATA;

  //   payload_initial['Submission']["SubmissionAddress"][0]["AddressZIPCode"] = "12345";
  //   payload_initial['Submission']["SubmissionAddress"][1]["AddressZIPCode"] = "12345";

  //   this.pr = this.pr.then(() => {
  //     // CommonService.coverage = CommonService.original_coverage;
  //     this.commonService.changeAllCoverage(CommonService.coverage);
  //     this.session_created = true;
     
  //     this.tesl.initiateQuote(payload_initial).then((data) => {
  //       this.tesl.readObject().then((data) => {
  //         var payload = TeslSchema.COVERAGE_UPDATE_DATA;
  //         this.tesl.updatePayloadWithObjectIDs(payload);
          
  //         this.tesl.updateObject(payload).then((data) => {
  //           this.rateFlow(true);
  //         });
  //       });
  //     });
  //   }); 
  // }

}
